import React from 'react';

import { ReactComponent as KioskIcon } from './imgs/kiosk.svg';
import { ReactComponent as PosIcon } from './imgs/pos.svg';

import { ReactComponent as ManagementIcon } from './imgs/management.svg';
import { ReactComponent as UkikiIcon } from './imgs/ukiki.svg';
import { ReactComponent as Arrow } from './imgs/arrow.svg';
import { ReactComponent as SimpleArrow } from './imgs/simple_arrow.svg';
import { ReactComponent as Spin } from './imgs/spin.svg';
import { ReactComponent as CigaMachine } from './imgs/ciga_machine.svg';

const CustomIcon = ({ width, height, color, icon }) => {
  const iconStyles = {
    width: width || 40,
    height: height || 40,
    fill: color || '#222',
    stroke: color || '#222',
  };

  return (
    <>
      {icon === 'kiosk' ? (
        <KioskIcon {...iconStyles} />
      ) : icon === 'pos' ? (
        <PosIcon {...iconStyles} />
      ) : icon === 'management' ? (
        <ManagementIcon {...iconStyles} />
      ) : icon === 'ukiki' ? (
        <UkikiIcon {...iconStyles} />
      ) : icon === 'arrow' ? (
        <Arrow {...iconStyles} />
      ) : icon === 'simpleArrow' ? (
        <SimpleArrow {...iconStyles} />
      ) : icon === 'spin' ? (
        <Spin />
      ) : icon === 'others' ? (
        <CigaMachine {...iconStyles} />
      ) : null}
    </>
  );
};

export default CustomIcon;
